import React from 'react'
import pitsMd from '../../Assests/Events/pitMdfullinside.svg'

function EventInsidePitMd() {

    const isMobile = window.innerWidth <= 768;

    return (
        <>

            <div className='mt-5 pt-5'>
                <div className='mx-2 mx-md-5 text-center'>
                    <img className='p-2 w-100 pitsburg-image-inside' src={pitsMd} alt='pitsMd' />
                </div>

                <div className='mx-2 mx-md-5 mt-2'>
                    <div className='pitsburg-headline-inside-text'>
                        Pitt Med + AI: Transforming Global Health Symposium
                    </div>
                    {isMobile ? (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', marginTop: '8px' }}>
              <div style={{ marginBottom: '8px' }}>
                <span className="Finished-status-pill py-2 px-4">Finished</span>
              </div>
              <div style={{ display: 'flex', flexDirection: 'row', gap: '8px' }}>
                <div className="time-status-pill py-2 px-2">
                  <span className="material-symbols-outlined me-1" style={{ fontSize: '18px' }}>
                    schedule
                  </span>
                  8:00 AM - 8:00 PM
                </div>
                <div className="time-status-pill py-2 px-4">
                  <span className="material-symbols-outlined me-1" style={{ fontSize: '18px' }}>
                    calendar_month
                  </span>
                  1st May, 2025
                </div>
              </div>
            </div>
          ) : (
            // Desktop layout: All in a row
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginTop: '8px' }}>
              <div style={{ marginRight: '8px' }}>
                <span className="Finished-status-pill py-2 px-4">Finished</span>
              </div>
              <div style={{ display: 'flex', gap: '8px' }}>
                <div className="time-status-pill py-2 px-4">
                  <span className="material-symbols-outlined me-1" style={{ fontSize: '18px' }}>
                    schedule
                  </span>
                  8:00 AM - 8:00 PM
                </div>
                <div className="time-status-pill py-2 px-4">
                  <span className="material-symbols-outlined me-1" style={{ fontSize: '18px' }}>
                    calendar_month
                  </span>
                  1st May, 2025
                </div>
              </div>
            </div>
          )}

                    {/* <div
                        className="d-inline-flex primary-btn py-2 px-4 careers-contact-us contact-us align-items-center mt-4"
                        onClick={() => window.open('https://www.health.pitt.edu/pitt-med-ai-transforming-global-health-symposium?utm_source=hsstratcomm_eblast&utm_medium=email&utm_campaign=ai_symposium_25&utm_content=invitation#Details', '_blank')}
                        style={{ cursor: 'pointer' }}
                    >
                        <div>Join Now</div>
                        <span className="material-symbols-outlined ms-1">
                            arrow_right_alt
                        </span>
                    </div> */}


                    <div className='mt-5'>
                        <div className='event-inside-heading'>
                            Venue :
                        </div>
                        <div className='event-inside-text mt-1'>
                            <div> May 1, 2025 - The University Club, Ballroom B </div>
                            <div> 123 University Place, Pittsburgh, PA  15213 </div>
                            <div>  Pitt campus in Oakland</div>
                        </div>
                    </div>

                    <div className='mt-3'>
                        <div className='event-inside-heading'>
                            Event Details:
                        </div>

                        <div className='event-inside-text-sub mt-1'>
                            <div>
                                The Pitt Med + AI: Transforming Global Health Symposium is a daylong event  during which Anantha Shekhar, senior vice chancellor for the health  sciences and John and Gertrude Petersen Dean of the School of Medicine,  and Joan Gabel, chancellor of the University of Pittsburgh since 2023,  will announce a partnership among the University of Pittsburgh School of Medicine, Vizzhy Longevity Inc., and other global leaders in AI health  care technology. The symposium will also mark a $50 million investment  in the University from those companies to support using AI to treat  diabetes, Alzheimer’s disease and other chronic diseases using  information gleaned from mass data sets.

                            </div>
                            <div className='mt-2'>Spend the day with us to learn how leveraging the world's most powerful AI  will dramatically affect health and health care delivery.</div>

                        </div>
                    </div>


                    <div className='mt-2'>
                        <div className='event-inside-heading'>
                            Preliminary Agenda:
                        </div>
                        <div className='event-inside-text-sub-head mt-2 '>
                            8:00 AM - 9:00 AM

                        </div>
                        <div className='event-inside-text-sub mt-1'>
                            Buck Institute for Research on Aging | Institute for Systems Biology | Phenome Health Inc.
                        </div>
                    </div>



                    <div>
                        <div className='event-inside-text-sub-head mt-1 '>
                            9:00 AM - 9:30 AM

                        </div>
                        <div className='event-inside-text-sub mt-1'>
                            Welcome and Opening Remarks
                        </div>
                    </div>

                    <div>
                        <div className='event-inside-text-sub-head mt-1 '>
                            9:30 AM - 9:45 AM
                        </div>
                        <div className='event-inside-text-sub mt-1'>
                            Signing Ceremony
                        </div>
                        <div>
                            University of Pittsburgh School of Medicine and Vizzhy Longevity Inc
                        </div>
                    </div>


                    <div>
                        <div className='event-inside-text-sub-head mt-1 '>
                            9:45 AM - 10:00 AM

                        </div>
                        <div className='event-inside-text-sub mt-1'>
                            Overview of the Partnership
                        </div>
                    </div>


                    <div>
                        <div className='event-inside-text-sub-head mt-1 '>
                            10:00 AM - 12:30 PM

                        </div>
                        <div className='event-inside-text-sub mt-1'>
                            Speaker Talks
                        </div>
                    </div>

                    <div>
                        <div className='event-inside-text-sub-head mt-1 '>
                            12:30 PM - 12:40 PM

                        </div>
                        <div className='event-inside-text-sub mt-1'>
                            Break   </div>
                    </div>

                    <div>
                        <div className='event-inside-text-sub-head mt-1 '>
                            12:40 PM - 1:40 PM

                        </div>
                        <div className='event-inside-text-sub mt-1'>
                            Lunch (provided)   </div>
                    </div>

                    <div>
                        <div className='event-inside-text-sub-head mt-1 '>
                            1:40 PM - 4:10 PM
                        </div>
                        <div className='event-inside-text-sub mt-1'>
                            Speaker Talks  </div>
                    </div>


                    <div>
                        <div className='event-inside-text-sub-head mt-1 '>
                            6:20 PM - 8:00 PM
                        </div>
                        <div className='event-inside-text-sub mt-1'>
                            Reception and Networking  </div>
                    </div>


                    <div className='mt-2'>
                        <div className='event-inside-heading'>
                            Speakers:
                        </div>
                        <div className='event-inside-text-sub-head mt-1 '>
                            Anantha Shekhar

                        </div>
                        <div className='event-inside-text-sub mt-1'>
                            <div>
                                Senior Vice Chancellor for the Health Sciences
                            </div>
                            <div className='ms-1'>
                                John and Gertrude Petersen Dean, School of Medicine, University of Pittsburgh
                            </div>
                        </div>
                    </div>


                    <div>
                        <div className='event-inside-text-sub-head mt-1 '>
                            Joan Gabel
                        </div>
                        <div className='event-inside-text-sub mt-1'>
                            Chancellor, University of Pittsburgh
                        </div>
                    </div>


                    <div>
                        <div className='event-inside-text-sub-head mt-1 '>
                            Leroy “Lee” Hood
                        </div>
                        <div className='event-inside-text-sub mt-1'>
                            <div>
                                Chief Innovation Officer and Distinguished Professor, Buck Institute for Research on Aging
                            </div>
                            <div className='ms-1'>
                                Founder and CEO, Phenome Health
                            </div>
                            <div className='ms-1'>
                                Cofounder and Professor, Institute for Systems Biology
                            </div>
                        </div>
                    </div>


                    <div>
                        <div className='event-inside-text-sub-head mt-1 '>
                            Adil Mardinoglu
                        </div>
                        <div className='event-inside-text-sub mt-1'>
                            <div>
                                Professor of Systems Biology, King’s College London
                            </div>
                            <div className='ms-1'>
                                Group Leader in the Science for Life Laboratory, KTH-Royal Institute of Technology
                            </div>
                        </div>
                    </div>

                    <div>
                        <div className='event-inside-text-sub-head mt-1 '>
                            Vishnuvardhan Pogunulu Srinivasulu
                        </div>
                        <div className='event-inside-text-sub mt-1'>
                            Founder and CEO, Vizzhy Inc.
                        </div>
                    </div>


                    <div>
                        <div className='event-inside-text-sub-head mt-1 '>
                            Chandan Sen
                        </div>
                        <div className='event-inside-text-sub mt-1'>
                            <div>
                                Associate Vice Chancellor of Life Sciences Innovation, Health Sciences
                            </div>
                            <div className='ms-1'>
                                Director, McGowan Institute for Regenerative Medicine, University of Pittsburgh
                            </div>
                        </div>
                    </div>


                    <div>
                        <div className='event-inside-text-sub-head mt-1 '>
                            Craig Mundie
                        </div>
                        <div className='event-inside-text-sub mt-1'>
                            <div>
                                President, Mundie and Associates
                            </div>
                        </div>
                    </div>



                    <div>
                        <div className='event-inside-text-sub-head mt-1 '>
                            Fiona Kaper
                        </div>
                        <div className='event-inside-text-sub mt-1'>
                            <div>
                                Vice President of Multiomics, Illumina Inc.
                            </div>
                        </div>
                    </div>


                    <div>
                        <div className='event-inside-text-sub-head mt-1 '>
                            Fritz Roth
                        </div>
                        <div className='event-inside-text-sub mt-1'>
                            <div>
                                John K. Vries Professor and Chair of Computational Biology, School of Medicine, University of Pittsburgh
                            </div>
                        </div>
                    </div>

                    <div>
                        <div className='event-inside-text-sub-head mt-1 '>
                            Hasan Türkez
                        </div>
                        <div className='event-inside-text-sub mt-1'>
                            <div>
                                Vice Rector and Professor of Medical Biology, Atatürk University
                            </div>
                        </div>
                    </div>


                    <div>
                        <div className='event-inside-text-sub-head mt-1 '>
                            Hooman Rashidi
                        </div>
                        <div className='event-inside-text-sub mt-1'>
                            <div>
                                Lombardi and Shinozuka Experimental Pathology Professor
                            </div>
                            <div className='ms-1'>
                                Associate Dean of Artificial Intelligence in Medicine, School of Medicine, University of Pittsburgh
                            </div>
                        </div>

                        <div>
                            <div className='event-inside-text-sub-head mt-1'>
                                Minho Shong
                            </div>
                            <div>
                                Cofounder of THOR Therapeutics and SILK Longevity
                            </div>
                            <div className='ms-1'>
                                Professor of Medicine, Korea Advanced Institute of Science and Technology (KAIST-GSMSE)
                            </div>

                        </div>


                        <div>
                            <div className='event-inside-text-sub-head mt-1'>
                                Nachiket Deshpande
                            </div>

                            <div className='ms-1'>
                                President of Global AI Services, Strategic Deals and Partnerships and Director, LTIMindtree
                            </div>

                        </div>


                        <div>
                            <div className='event-inside-text-sub-head mt-1'>
                                Nathan Price
                            </div>

                            <div className='ms-1'>
                                Professor and Codirector, Center for Human Healthspan, Buck Institute for Research on Aging
                            </div>

                        </div>


                        <div>
                            <div className='event-inside-text-sub-head mt-1'>
                                Sunil Gupta
                            </div>

                            <div className='ms-1'>
                                Cofounder, Managing Director and CEO, Yotta
                            </div>

                        </div>


                        <div>
                            <div className='event-inside-text-sub-head mt-1'>
                                Vivek Goswami
                            </div>
                            <div className='ms-1'>
                                Board of Directors American Heart Association (Austin)
                            </div>
                            <div className='ms-2'>
                                Chairman of Nuclear Medicine at Austin Heart
                            </div>

                        </div>

                    </div>

                    <div>

                    </div>
                </div>
            </div>
        </>
    )
}

export default EventInsidePitMd
